export default __webpack_public_path__ + "static/media/330_portfolio04-en-mobile.31fe9c47.png";